import React, { useState, useEffect } from 'react'
import { style } from './style'
import { useAvailableSlots } from "../store/stateProvider"
import DisplayDetails from '../details-card'
import CircularProgress from '../loader'
import ErrorBox from '../error-box'
import useTranslation from '../../../hooks/use-translation';
import config from '../../../config.json'
import { openBrowser } from '../../../utils/call-my-jio'
import { raiseGAEventForSlotFinder } from '../../../utils/network'
import { formatDate } from '../details-card'

const DisplaySlots = (props) => {
  const { t } = useTranslation();
  const [data, dispatch] = useAvailableSlots()
  const [displayDetails, setDislayDetails] = useState({ currentDate: '', displayDetailedData: false })
  const [available_capacity, setAvailable_capacity] = useState(true)
  const { slots, apiResponseCode = '' } = data

  const dataToDisplay = Object.keys(slots) || []
  const renderCenterDetails = (element) => {
    setDislayDetails({ currentDate: element, displayDetailedData: true })
  }
  const renderViewAllDates = () => {
    setDislayDetails({ currentDate: '', displayDetailedData: false })
  }
  useEffect(() => {
    if (apiResponseCode === 'pending') {
      renderViewAllDates()
    }
  }, [apiResponseCode])

  useEffect(() => {
    dispatch({
      type: 'FILTER',
      keywords: { available_capacity: true },
      initialSlots: data.initialSlots
    })
  }, [])
  
  const bookCowin = () => {
    raiseGAEventForSlotFinder({ eventAction: 'Book on Cowin', eventLabel: 'Click' })
    openBrowser(config.cowinRegistrationLink)
  }
  const filterByAvailableCapacity = () => {
    filter('available_capacity', !available_capacity)
  }
  const filter = (keyword = '', value = '') => {
    setAvailable_capacity(value)
    dispatch({
      type: 'FILTER',
      keywords: { available_capacity: value },
      initialSlots: data.initialSlots
    })
  }

  return (
    <>
      <div style={style.showOnlyAvailableSlotsFlexbox}>
        <div>Show only available slots</div>
        <img src={available_capacity ? "/icons/ic_on_toggle.svg" : "/icons/ic_off_toggle.svg"} onClick={() => { filterByAvailableCapacity() }} />
      </div>
      <div style={{ marginBottom: '12px', width: '100%', zIndex: 1 }}>
        {apiResponseCode === 'failure' &&
          <ErrorBox src={"/icons/ic_cat.svg"} label={'We are unable to process your request. Please try again after some time.'} />}
        {apiResponseCode === 'pending' &&
          <div style={{ display: 'flex', placeContent: 'center' }}>
            <CircularProgress show={true} height={'20px'} width={'20px'} borderTopColor={'#F6F6F6'} borderWidth={'2px'} />
          </div>}
        {apiResponseCode === 'success' &&
          <div style={{ width: '100%', backgroundColor: '#FFFFFF', borderRadius: '10px' }}>
            {!!dataToDisplay.length && !displayDetails.displayDetailedData && dataToDisplay.map((element, index) => {
              const slotsByPlace = slots[element] || []
              let totalSlot = 0
              slotsByPlace.forEach((element) => {
                const { sessions = [] } = element
                sessions.forEach((session) => {
                  totalSlot += Number(session["available_capacity"])
                })
              })
              return (
                <div style={style.availbleSlotsContainer(index)} key={`display-slot-date-${index + 1}`} onClick={renderCenterDetails.bind(props, element)}>
                  <div>
                    {formatDate(element)}
                  </div>
                  <div style={{ display: 'flex' }}>
                    <div style={style.totalNumberOfSlotsBox(totalSlot)}>
                      {`${totalSlot} ${totalSlot > 1 ? 'slots' : 'slot'}`}
                    </div>
                    <img src="/icons/ic_right_arrow.svg" style={{ paddingLeft: '16px' }} />
                  </div>
                </div>
              )
            })}
            {dataToDisplay.length > 0 && !displayDetails.displayDetailedData && <div style={style.cowinDiv}>
              <button style={style.cowinButton} type="button" value={t('BOOK_COWIN')}
                onClick={bookCowin} >{t('BOOK_COWIN')}</button>
            </div>}
            {!dataToDisplay.length && !displayDetails.displayDetailedData &&
              <ErrorBox src={"/icons/ic_sad_face.svg"} label={t('NO_SLOT_AREA')} />}
          </div>}
        {!!dataToDisplay && displayDetails.displayDetailedData &&
          <DisplayDetails currentDate={displayDetails.currentDate} allDateCenters={slots}
            renderAllDatesFunction={() => { setDislayDetails({ ...displayDetails, displayDetailedData: false }) }} />}
      </div>
    </>
  )
}

export default DisplaySlots